import { Fancybox } from "@fancyapps/ui";




export const initGallery = () => {




    var fancyboxContainer = document.querySelectorAll('.gallery-block__gallery-container');
    if (fancyboxContainer) {
        Fancybox.bind('[data-fancybox="gallery"]', {
            Carousel: {
                Dots: false,
            },
        });
    }




}